
import React from "react";
import { i18nManager } from "../i18n";
import PageHead from "./common/PageHead";
import TrophyCard from "./common/TrophyCard";
import FilterChips from "./common/FilterChips";
import styles from "../assets/style.module.css";
import { TROPHIES, TrophyTier } from "../data";

function Achievements() {

    const labels = i18nManager.Labels.achievements;
    const [tier, setTier] = React.useState("");
    const tiers: TrophyTier[] = ["gold", "silver", "bronze", "special"];
    const counts = tiers.map((t) => [t, TROPHIES.filter((x) => x.tier === t).length] as [TrophyTier, number]);

    return (<>
        <PageHead kicker={labels.kicker} title={labels.title} subtitle={labels.desc}>
            <div className={styles["stat-row"]}>
                {counts.map(([t, count]) => (<div key={t} className={styles["stat"]}>
                    <span className={styles["stat-val"]}>{count}</span>
                    <span className={styles["stat-lbl"]}>{labels[t]}</span>
                </div>))}
            </div>
        </PageHead>
        <section className={styles["section-page"]}>
            <div className={styles["container"]}>
                <FilterChips value={tier} onChange={setTier} options={[["", labels.all], ...tiers.map((t) => [t, labels[t]] as [string, string])]} />
                <div className={styles["trophy-grid"]}>
                    {TROPHIES.filter((t) => !tier || t.tier === tier).map((t) => (<TrophyCard key={t.id} trophy={t} />))}
                </div>
            </div>
        </section>
    </>);
}

export default Achievements;
